import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { LINKEDIN_WIZARDS } from '@bingads-webui-campaign-react/linkedin-utils';
import { mergeClasses } from '@fluentui/react-components';

import { LinkedInBaseSingleStepWizard } from './base-single-step-wizard';
import { useWizardStyles } from './styles/wizard-styles';

export const LinkedInAdGroupSettingsWizard = ({ siteMap, scope, ...restProps }) => {
  const classes = useWizardStyles();
  const navigateToSomeWhere = useCallback(() => scope.save(getRoutePathById(siteMap, 'adgroups')), [scope, siteMap]);

  return (
    <div className={mergeClasses('adgroup-settings-wizard', classes.wizardContainer)}>
      <LinkedInBaseSingleStepWizard
        scenario={LINKEDIN_WIZARDS.AD_GROUP_SETTINGS}
        onDone={navigateToSomeWhere}
        onExited={navigateToSomeWhere}
        {...restProps}
      />
    </div>
  );
};

LinkedInAdGroupSettingsWizard.propTypes = {
  siteMap: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
};
